import React from 'react'
import CRUD from '../../components/common/CRUD/CRUD'
import { fields, extraActions } from '../../models/sales/companyModel'
import { createCRUDService } from '../../services/crudService'
import { Breadcrumb } from 'react-bootstrap'

const CompaniesView = () => {
  const { listItems, deleteItem, createItem, updateItem } = createCRUDService(
    '/api/sales/companies'
  )
  return (
    <main style={{ padding: '1rem 0' }}>
      <CRUD
        fields={fields}
        extraActions={extraActions}
        paginated
        entityName='Compañia'
        entityNamePlural='Compañias'
        dataSource={listItems}
        onDelete={deleteItem}
        onCreate={createItem}
        onUpdate={updateItem}
      />
    </main>
  )
}

CompaniesView.breadcrumbs = () => (
  <Breadcrumb.Item key='breadcrumb-companies' href='/companies' active>
    Compañias
  </Breadcrumb.Item>
)

export default CompaniesView
